// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"656457bc","15":"cd92558f","79":"0236ce53","305":"d4b0eb09","453":"c3bf7436","465":"ceec353f","470":"f32dd5ac","561":"c96b57f1","574":"820164af","620":"ac53a36c","753":"9f4ee7c1","836":"d5ef002c","928":"db1058f5","978":"22cbd2d6"}[chunkId] + ".chunk.js";
};